import { Button, Dropdown, Menu, Slider } from "antd";
import React from "react";
import { UserOutlined } from "@ant-design/icons";
import media from "../../../media";
import { NavLink } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { logoutAdmin } from "../../../store/thunks/authThunk";

const Header = () => {
  const dispatch = useDispatch();

  //Super Admin Start
  const { user } = useSelector((state) => state.auth);
  const isSuperAdmin = user?.userType === "SUPER_VENDOR";

  //Super Admin End

  const handleLogout = () => {
    dispatch({ type: "RESET_STORE" });
    dispatch(logoutAdmin());
  };
  //Top User Menu Start
  const menu = [
    ...(!isSuperAdmin
      ? [
          {
            label: <NavLink to="/myProfile">My Profile</NavLink>,
            key: "1",
          },
          {
            label: <NavLink to="/storeSetting">Store Settings</NavLink>,
            key: "2",
          },
        ]
      : []),

    {
      label: (
        <span
          className="menu-link cursor-pointer"
          onClick={() => {
            handleLogout();
          }}
        >
          <span className="menu-text">Logout</span>
        </span>
      ),
      key: "3",
    },
  ];

  //Top User Menu End

  return (
    <>
      <div className="top_header">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between">
            <div className="left_side">
              <NavLink to="/dashBoard" className="logo">
                <img alt="Logo" src={media.ak_logo} className="logo_img" />
              </NavLink>
            </div>
            <div className="right_side">
              <ul className="top_icons m-0">
                {/* <li
                  className="border border-1 border-light-dark"
                  style={{ padding: "2.53px 7px" }}
                >
                  <NavLink to="/notification">
                    <i className="flaticon2-bell-4 text-dark-65"></i>
                  </NavLink>
                </li> */}

                <li>
                  <Dropdown menu={{ items: menu }} placement="bottomLeft">
                    <Button size="middle" className="ant-btn-icon-only">
                      <UserOutlined />
                    </Button>
                  </Dropdown>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="menu_header menu_header">
        <div className="container">
          <div className="navbars">
            <div className="first_top_menu">
              <ul className="first_list">
                {!isSuperAdmin && (
                  <>
                    <li className="mega_hover_link">
                      <NavLink to="/dashBoard" className="menu-link">
                        <span className="menu-text">Home</span>
                        <span className="menu-desc"></span>
                      </NavLink>
                    </li>
                    <li className="mega_hover_link">
                      <span className="menu_item_first dropdown_arrows custom_menu">
                        Catalog
                      </span>
                      <div className="menu-submenu menu-submenu-classic menu-submenu-left">
                        <ul className="menu-subnav">
                          <li className="menu-item" aria-haspopup="true">
                            <NavLink
                              to="/addProductToInventory"
                              className="menu-link"
                            >
                              <span className="menu-text">
                                Add Product to Inventory
                              </span>
                              <span className="menu-desc"></span>
                            </NavLink>
                          </li>
                          <li className="menu-item" aria-haspopup="true">
                            <NavLink
                              to="/requestNewProduct"
                              className="menu-link"
                            >
                              <span className="menu-text">
                                Request a New Product
                              </span>
                              <span className="menu-desc"></span>
                            </NavLink>
                          </li>
                          <li className="menu-item" aria-haspopup="true">
                            <NavLink
                              to="/trackApprovalRequests"
                              className="menu-link"
                            >
                              <span className="menu-text">
                                Track Approval Requests
                              </span>
                              <span className="menu-desc"></span>
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="menu-item" aria-haspopup="true">
                      <NavLink to="/Inventory" className="menu-link">
                        <span className="menu-text">Inventory</span>
                        <span className="menu-desc"></span>
                      </NavLink>
                    </li>
                  </>
                )}

                <li className="mega_hover_link">
                  <NavLink to="/Orders">Orders</NavLink>
                </li>

                {!isSuperAdmin && (
                  <>
                    <li className="mega_hover_link">
                      <NavLink to="/reportsAnalytics">R&A</NavLink>
                    </li>
                    {/* <li className="mega_hover_link">
                  <NavLink to="/couponList">Coupons</NavLink>
                </li> */}
                    <li className="menu-item" aria-haspopup="true">
                      <NavLink to="/Return" className="menu-link">
                        <span className="menu-text">Returns</span>
                        <span className="menu-desc"></span>
                      </NavLink>
                    </li>
                    <li className="menu-item" aria-haspopup="true">
                      <NavLink to="/reviewsList" className="menu-link">
                        <span className="menu-text">Reviews</span>
                        <span className="menu-desc"></span>
                      </NavLink>
                    </li>

                    <li className="menu-item" aria-haspopup="true">
                      <NavLink to="/settlements" className="menu-link">
                        <span className="menu-text">Settlements</span>
                        <span className="menu-desc"></span>
                      </NavLink>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
